  export const LISTA_PLATAFORMAS: { value: string; name: string }[] = [
    {
      value: '1',
      name: 'VentaOnline'
    },
    {
      value: '2',
      name: 'TaquiaCore'
    },
    {
      value: '3',
      name: 'TaquillaAutomatica'
    },
    {
      value: '4',
      name: 'AdminCentral'
    },
    {
      value: '5',
      name: 'Customman'
    },
  ];

export const LISTA_PLATAFORMAS_DATOS = {
  1: 'VentaOnline',
  2: 'TaquiaCore',
  3: 'TaquillaAutomatica',
  4: 'AdminCentral',
  5: 'Customman'
}